<script setup lang="ts">
import StackLayout from '@/components/Layouts/StackLayout.vue'
import { ref } from 'vue'
import SecondaryButton from '../../../components/Buttons/SecondaryButton.vue'
import { isMobile, isMobileEvent } from '../../../utils/viewsUtils'

const showFilters = ref(false)

const isMobileLayout = ref(isMobile())
isMobileEvent(e => (isMobileLayout.value = e.matches))
</script>

<template>
    <StackLayout v-if="isMobileLayout" :gap="8" class="full-width" isResponsive>
        <SecondaryButton
            v-if="showFilters"
            :label="$t('common.hideFilters')"
            @click="showFilters = false" />
        <SecondaryButton v-else :label="$t('common.showFilters')" @click="showFilters = true" />

        <slot v-if="showFilters" :name="$slots['mobile'] ? 'mobile' : 'default'" />
    </StackLayout>
    <slot v-else :name="$slots['desktop'] ? 'desktop' : 'default'" />
</template>
